import React, {Component} from 'react'

class FolderBrowse extends Component {

  handleChangeFiler(filter){
    this.props.onFilterChange(filter)
  }

  handleItemClick(item){
    if (this.props.activeItem.title == item.title) {
      item = '';
    }
    this.props.onHandleItemClick(item);
  }

  render(){

    return(
      <ul className="sp-pagebuilder-media">
      {
        this.props.filtered != sppbMediaPath &&
          <li
            className="sp-pagebuilder-media-folder sp-pagebuilder-media-to-folder-back"
            onClick={(e)=>{
              e.preventDefault();
              var slashIndexOf = this.props.filtered.lastIndexOf('/');
              let folderPath = this.props.filtered.substring(0,slashIndexOf)
              this.handleChangeFiler(folderPath)
            }}
            >
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <i className="fa fa-arrow-left fa-4x"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span className="sp-pagebuilder-media-title">Go Back</span>
            </div>
          </li>
        }
        {
          this.props.folders.map((folder,index)=>{
            return(
              <li
                key={index}
                className="sp-pagebuilder-media-folder"
                onDoubleClick={(e) => {
                  e.preventDefault();
                  var filter = this.props.filtered + '/' +folder;
                  this.handleChangeFiler(filter)
                }}
              >
                <div>
                  <div>
                    <div>
                      <div>
                        <div>
                          <div>
                            <i className="fa fa-folder"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <span className="sp-pagebuilder-media-title">{folder}</span>
              </div>
            </li>)
          })
        }
        {
          this.props.items.map((item,index)=>{
            var itemCustomCls = 'sp-pagebuilder-media-item';
            if (item.title == this.props.activeItem.title) {
              itemCustomCls += ' selected'
            }

            return(
              <li
                key={index}
                className={itemCustomCls}
                onClick={(e)=>{
                  e.preventDefault();
                  this.handleItemClick(item);
                }}
              >

              <div>
                <div>
                  <div>
                    <div>
                      <img src = { item.src }/>
                    </div>
                  </div>
                </div>
                <span className="sp-pagebuilder-media-title"><span><i className="fa fa-picture-o"></i> <span> {item.title}</span>.{item.ext}</span></span>
              </div>
              </li>
          )})
        }
      </ul>
    )
  }
}

export default FolderBrowse;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/FolderBrowse.js